import React from 'react'

import { withTranslation } from 'react-i18next'

import Icon, { IconNames } from 'components/icons'
import theme from 'components/theme'
import {
  MobileContainer,
  Title,
  TextOriginDest,
  TextContainer,
  Wrapper,
  Separator,
  Header,
  WrapperPadding,
  DateWrapper,
  DateTextWrapper
} from './styled'

import { getDateWithFormat } from 'helpers/dates'
import FORMATS from 'constants/formats'
import NAMESPACES from 'localization/constants/namespaces'

class FlightsSearchBoxMobile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showSearchBox: props.isDefaultExpanded
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isDefaultExpanded !== this.props.isDefaultExpanded) {
      this.setState({ showSearchBox: this.props.isDefaultExpanded })
    }
  }

  showSearchBox = () => {
    this.setState({
      showSearchBox: !this.state.showSearchBox
    })
    this.props.onExpand && this.props.onExpand()
  }

  getLandingHeader = () => (
    <Title>{this.props.t('scheduled-flights.search-box.header-mobile')}</Title>
  )

  getCollapsibleHeader = () => {
    const { origin, destination, departureDate, flightNumber, fontSize } = this.props
    const text = flightNumber || `${origin} - ${destination}`

    return (
      <Header onClick={this.showSearchBox}>
        <TextContainer>
          <TextOriginDest fontSize={fontSize}>{text}</TextOriginDest>
          <WrapperPadding>|</WrapperPadding>
          <DateWrapper>
            <Icon name={IconNames.Calendar} size={14} color={theme.colors.doveGray} />
            <DateTextWrapper>{getDateWithFormat(departureDate, FORMATS.DAY_MONTH)}</DateTextWrapper>
          </DateWrapper>
        </TextContainer>
        <Wrapper>
          <Icon
            name={this.state.showSearchBox ? IconNames.ChevronUp : IconNames.ChevronDown}
            size={20}
            color={theme.colors.blue}
          />
        </Wrapper>
      </Header>
    )
  }

  getChildrenWithProps = () => {
    const { children } = this.props

    return React.Children.map(children, child =>
      React.cloneElement(child, { hidden: !this.state.showSearchBox })
    )
  }

  render() {
    const { origin, destination, departureDate, flightNumber } = this.props
    const landingSearchBox =
      !(origin && departureDate && destination) && !(flightNumber && departureDate)

    return (
      <MobileContainer landingSearchBox={landingSearchBox} expandedSB={this.state.showSearchBox}>
        {landingSearchBox ? this.getLandingHeader() : this.getCollapsibleHeader()}
        <Separator expandedSB={this.state.showSearchBox} />
        {this.getChildrenWithProps()}
      </MobileContainer>
    )
  }
}

export default withTranslation(NAMESPACES.SCHEDULED_FLIGHTS)(FlightsSearchBoxMobile)
